import {
    DIVISIONS_FETCHING,
    DIVISIONS_FAILED,
    DIVISIONS_SUCCESS
} from "../actions/types";

const initialState = {
    result: null,
    isFetching: false,
    isError: false,
};

export default function (state = initialState, action) {
    const { type, payload } = action;
    switch (type) {
      case DIVISIONS_FETCHING:
        return { ...state, result: null, isFetching: true, isError: false };
      case DIVISIONS_FAILED:
        return { ...state, result: null, isFetching: false, isError: true };
      case DIVISIONS_SUCCESS:
        return { ...state, result: payload, isFetching: false, isError: false };
      default:
        return state;
    }
};
